import { ChatPanel, MessageEncryptedTip } from '@halo/ui-chat-react';
import { Fragment } from 'react/jsx-runtime';
import { useStore } from 'zustand';
import { useShallowEnhance } from '@halo/zustand-enhance';
import type { SessionStoreInstance } from '@/store/client';
import { useRobotInfo } from '@/components/RobotProfileDialog/Helper';
import { useActionsStore } from '@/store/actions';
import {
  SessionBody,
  SessionHeader,
  SessionMsgList,
  SessionMessages,
  SessionContentsContextProvider,
} from '../../session-parts';

export interface SessionBotProps {
  visible: boolean;
  sessionStoreInstance: SessionStoreInstance;
}

export function SessionBot({ visible, sessionStoreInstance }: SessionBotProps) {
  const sessionStore = useStore(sessionStoreInstance)!;
  const { setProfileRobot } = useActionsStore(useShallowEnhance(['setProfileRobot']));
  const robotInfo = useRobotInfo(sessionStore?.session?.user_info);

  const handleAvatarClick = useCallback(async () => {
    const robot_id = sessionStore?.session?.user_info?.user_id;
    if (robot_id) {
      setProfileRobot(robot_id);
    }
  }, [sessionStore?.session?.user_info, setProfileRobot]);

  const renderFirstMessage = useCallback((key: string) => {
    return (
      <Fragment key={key}>
        <MessageEncryptedTip />
        {/* <MessageDestroyTip /> */}
      </Fragment>
    );
  }, []);
  return (
    <SessionContentsContextProvider sessionStoreInstance={sessionStoreInstance}>
      <ChatPanel visible={visible}>
        <SessionHeader
          sessionStore={sessionStore}
          isGroup={false}
          isGroupDisband={false}
          isInGroup={false}
          isRobot={true}
          tooltip={robotInfo?.tooltip}
          official={robotInfo?.isofficial}
          onAvatarClick={handleAvatarClick}
        />
        <SessionBody>
          <SessionMsgList sessionStore={sessionStore}>
            <SessionMessages
              renderFirstMessage={renderFirstMessage}
              sessionStore={sessionStore}
            />
          </SessionMsgList>
        </SessionBody>
      </ChatPanel>
    </SessionContentsContextProvider>
  );
}
